import styled from '@emotion/styled';
import { Button, Typography } from 'antd';
import { useTranslate } from '@tolgee/react';

const { Text } = Typography;

const Wrap = styled.div`
  display: flex;
  align-items: center;
  background: rgba(215, 225, 250, 1);
  justify-content: space-between;

  & > .ant-typography {
    padding: 0 16px;
  }
`;

export interface CacheTipsProps {
  visible?: boolean;
  onClick?: () => void;
}

const CacheTips = (props: CacheTipsProps) => {
  const { visible, onClick } = props;
  const { t } = useTranslate();

  return visible ? (
    <Wrap>
      <Text ellipsis>{t('chatWorkspace.couponForm.banner.unsavedData')}</Text>
      <Button
        type="link"
        onClick={() => {
          onClick && onClick();
        }}
      >
        {t('common.action.clear')}
      </Button>
    </Wrap>
  ) : null;
};

export default CacheTips;
